// src/components/PromptLibraryButton.js
import React from 'react';
import './PromptLibraryButton.css';

function PromptLibraryButton({ onClick }) {
  return (
    <button 
      className="prompt-library-button" 
      onClick={onClick}
      title="Save to Prompt Library"
    >
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width="16" 
        height="16" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      >
        <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
      </svg>
    </button>
  );
}

export default PromptLibraryButton;